{
  "app": {
    "title": "AI Trading",
    "subtitle": "админка",
    "logout": "Выйти",
    "role": {
      "superadmin": "Суперадминистратор",
      "operator": "Оператор"
    }
  },
  "nav": {
    "dashboard": "Сводка",
    "deposits": "Пополнения",
    "withdrawals": "Выводы",
    "users": "Пользователи",
    "robots": "Роботы",
    "accruals": "Начисления",
    "settings": "Настройки",
    "audit": "Журнал",
    "admins": "Администраторы",
    "comments": "Отзывы"
  },
  "login": {
    "title": "Вход в админку",
    "hint": "Логин и пароль.",
    "login": "Логин",
    "password": "Пароль",
    "submit": "Войти",
    "required": "Заполните поле"
  },
  "common": {
    "actions": "Действия",
    "cancel": "Отмена",
    "save": "Сохранить",
    "confirm": "Подтвердить",
    "reject": "Отклонить",
    "comment": "Комментарий",
    "commentRequired": "Причина обязательна — пользователь увидит её в приложении",
    "amount": "Сумма",
    "date": "Дата",
    "created": "Создана",
    "status": "Статус",
    "user": "Пользователь",
    "id": "ID",
    "loadMore": "Показать ещё",
    "empty": "Ничего нет",
    "search": "Поиск",
    "yes": "Да",
    "no": "Нет",
    "back": "Назад",
    "refresh": "Обновить",
    "notFound": "Страница не найдена",
    "toDashboard": "К сводке",
    "error": "Ошибка",
    "success": "Готово",
    "requisites": "Реквизиты",
    "noData": "—"
  },
  "status": {
    "pending": "На рассмотрении",
    "approved": "Подтверждена",
    "rejected": "Отклонена",
    "paid": "Выплачена",
    "active": "Работает",
    "stopped": "Остановлен",
    "blocked": "Заблокирован",
    "paused": "Временно недоступен",
    "hidden": "Скрыт",
    "published": "Опубликован",
    "flagged": "Жалобы",
    "deleted": "Удалён"
  },
  "dashboard": {
    "title": "Сводка",
    "usersTotal": "Пользователей",
    "usersBlocked": "из них заблокировано",
    "robotsActive": "Роботов в каталоге",
    "userRobotsActive": "Работающих роботов",
    "depositsPending": "Заявок на пополнение",
    "withdrawalsPending": "Заявок на вывод",
    "totalBalance": "Суммарный баланс",
    "investedTotal": "Вложено в роботов",
    "lastAccrual": "Последнее начисление",
    "noAccruals": "начислений ещё не было",
    "recentActions": "Последние действия",
    "subtitle": "Что происходит в проекте прямо сейчас",
    "allActions": "Весь журнал",
    "emptyActions": "Действий пока не было"
  },
  "deposits": {
    "title": "Заявки на пополнение",
    "method": "Способ",
    "asset": "Актив",
    "network": "Сеть",
    "address": "Адрес",
    "txHash": "Хеш транзакции",
    "noHash": "хеш не приложен",
    "approve": "Подтвердить и зачислить",
    "approveConfirm": "Баланс пользователя будет увеличен на {{amount}}. Действие необратимо.",
    "rejectTitle": "Отклонить заявку",
    "approved": "Заявка подтверждена, баланс зачислен",
    "rejected": "Заявка отклонена",
    "subtitle": "Деньги, которые пользователи заводят в проект",
    "empty": "Заявок на пополнение нет",
    "payment": {
      "title": "Платёж NOWPayments",
      "id": "ID платежа",
      "status": "Статус платежа",
      "expected": "Ожидалось",
      "received": "Получено",
      "underpaid": "недоплата",
      "overpaid": "переплата",
      "parent": "Доплата к платежу",
      "expires": "Действует до",
      "none": "Платежа нет: заявка создана до перехода на шлюз"
    }
  },
  "withdrawals": {
    "title": "Заявки на вывод",
    "asset": "Актив",
    "network": "Сеть",
    "address": "Адрес",
    "txHash": "Хеш выплаты",
    "approve": "Подтвердить и списать",
    "approveConfirm": "С баланса пользователя будет списано {{amount}}. Деньги уйдут в резерв до отметки о выплате.",
    "paid": "Отметить выплаченной",
    "paidTitle": "Отметка о выплате",
    "paidHint": "Хеш транзакции увидит пользователь в приложении.",
    "rejectTitle": "Отклонить заявку",
    "rejectRefundHint": "Заявка подтверждена, поэтому списанные {{amount}} вернутся на баланс пользователя.",
    "rejectNoRefundHint": "Деньги ещё не списывались — баланс не изменится.",
    "approved": "Вывод подтверждён, средства списаны",
    "markedPaid": "Выплата отмечена",
    "rejected": "Заявка отклонена",
    "subtitle": "Выплаты, ожидающие вашего решения",
    "empty": "Заявок на вывод нет"
  },
  "users": {
    "title": "Пользователи",
    "searchPlaceholder": "Имя, username, telegram_id или id",
    "onlyBlocked": "Только заблокированные",
    "balance": "Баланс",
    "registered": "Регистрация",
    "detailTitle": "Пользователь {{id}}",
    "language": "Язык",
    "notifications": "Уведомления",
    "referralCode": "Реферальный код",
    "referredBy": "Приглашён пользователем",
    "invitedCount": "Приглашено",
    "invested": "Вложено в роботов",
    "earned": "Заработано роботами",
    "robots": "Роботы",
    "robot": "Робот",
    "purchasePrice": "Цена покупки",
    "earnedTotal": "Результат",
    "purchasedAt": "Куплен",
    "transactions": "Операции",
    "transactionType": "Тип",
    "balanceAfter": "Баланс после",
    "adjust": "Скорректировать баланс",
    "adjustHint": "Сумма со знаком: минус списывает. Операция пройдёт через общий лог и попадёт в журнал администратора.",
    "adjustAmount": "Сумма корректировки",
    "adjustDone": "Баланс скорректирован",
    "block": "Заблокировать",
    "unblock": "Разблокировать",
    "blockConfirm": "Пользователь перестанет открывать приложение. Роботы продолжат работать.",
    "blockDone": "Пользователь заблокирован",
    "unblockDone": "Блокировка снята",
    "subtitle": "Все, кто зарегистрировался в приложении",
    "empty": "Никого не нашлось",
    "emptyHint": "Попробуйте изменить запрос или снять фильтр",
    "filterAll": "Все",
    "filterActive": "Активные",
    "filterBlocked": "Заблокированные",
    "noRobots": "Роботы не куплены",
    "noTransactions": "Операций не было",
    "card": "Общие сведения",
    "resetDemo": "Сбросить демо",
    "resetDemoConfirm": "Вернуть стартовый виртуальный баланс и закрыть демо-позиции? Реальный счёт не изменится.",
    "resetDemoDone": "Демо-счёт сброшен",
    "service": "Служебный",
    "serviceOn": "Пометить служебным",
    "serviceOff": "Снять пометку",
    "serviceHint": "Служебный аккаунт исключён из рейтинга участников, из подиума ТОП-3 и из аудитории роботов. Доступ пометка не закрывает.",
    "publicRating": "Публичный рейтинг",
    "publicRatingOn": "Имя видно",
    "publicRatingOff": "Анонимно",
    "publicRatingHint": "Согласие даёт сам пользователь в настройках профиля.",
    "serviceOnDone": "Аккаунт помечен служебным",
    "serviceOffDone": "Пометка снята"
  },
  "transactionType": {
    "deposit": "Пополнение",
    "withdrawal": "Вывод",
    "robot_purchase": "Покупка робота",
    "daily_profit": "Прибыль за день",
    "daily_loss": "Убыток за день",
    "referral_bonus": "Реферальный бонус",
    "admin_adjust": "Корректировка администратором"
  },
  "robots": {
    "title": "Роботы",
    "create": "Завести робота",
    "createTitle": "Новый робот",
    "editTitle": "Робот {{name}}",
    "code": "Код",
    "codeHint": "Латиница, цифры, дефис. После создания не меняется.",
    "name": "Название",
    "description": "Описание",
    "howItWorks": "Как принимает решения",
    "market": "Рынок",
    "riskLevel": "Риск",
    "declaredYield": "Заявленная доходность за 12 мес., %",
    "declaredMaxDd": "Просадка на карточке, %",
    "generator": "Настройки генерации",
    "dailyMin": "Минимум за день, %",
    "dailyMax": "Максимум за день, %",
    "positiveChance": "Вероятность плюсового дня, %",
    "sortOrder": "Порядок",
    "purchases": "Покупок",
    "preview": "Расчёт по настройкам",
    "previewHint": "Прогон генератора на 365 дней вперёд — те же формулы, по которым идут ночные начисления.",
    "expectedYield": "Расчётная доходность за 12 мес",
    "maxDrawdown": "Максимальная просадка",
    "positiveDays": "Плюсовых дней",
    "bestDay": "Лучший день",
    "worstDay": "Худший день",
    "mismatch": "Цифра на карточке ({{declared}} %) расходится с чистой расчётной ({{actual}} %) больше чем в полтора раза. На первом же вопросе инвестора это будет видно.",
    "rangeError": "Диапазон обязан включать ноль: минимум не больше нуля, максимум не меньше.",
    "created": "Робот заведён",
    "updated": "Изменения сохранены",
    "market_spot": "Спот",
    "market_futures": "Фьючерсы",
    "risk_low": "Низкий",
    "risk_medium": "Средний",
    "risk_high": "Высокий",
    "subtitle": "Каталог торговых роботов и их настройки",
    "empty": "Роботов пока нет",
    "emptyHint": "Заведите первого — он появится в каталоге приложения",
    "card": "Карточка робота",
    "declaredYieldHint": "Ориентир оператора. Инвестору показывается посчитанная доходность — держите эту цифру рядом с ней, иначе форма начнёт ругаться.",
    "appearance": "Внешний вид",
    "image": "Картинка",
    "imageHint": "PNG, JPEG или WebP до 512 КБ. Квадратная — в приложении она обрезается в круг.",
    "imageChoose": "Выбрать файл",
    "imageRemove": "Убрать картинку",
    "imageUploaded": "Картинка загружена",
    "imageRemoved": "Картинка убрана",
    "imagePendingHint": "Файл загрузится сразу после сохранения робота.",
    "accentColor": "Акцентный цвет",
    "accentColorHint": "Цвет рамки и подписей на карточке. Пусто — цвет по коду робота.",
    "showcase": "Витрина и торговля",
    "profitFeePct": "Комиссия с прибыли, %",
    "profitFeeHint": "До 15%. Удерживается раз в сутки и только с прибыльного дня. Ноль — робот работает без комиссии.",
    "usersCount": "Пользователей на витрине",
    "profitTotal": "Общий профит на витрине",
    "showcaseHint": "Цифры социального доказательства на карточке каталога. Не считаются по покупкам.",
    "assets": "Токены",
    "assetsHint": "Тикеры заглавными: BTC, ETH. Показываются чипами у названия.",
    "exchanges": "Биржи",
    "pairs": "Пары",
    "pairsHint": "В формате BTC/USDT.",
    "leverage": "Плечо",
    "timeframe": "Таймфрейм",
    "tradesPerDay": "Сделок в сутки",
    "avgHold": "В позиции",
    "tagsHint": "Enter — добавить значение.",
    "expectedYieldNet": "Чистая доходность за 12 мес",
    "expectedYieldNetHint": "После комиссии платформы. Именно с ней сверяется цифра на карточке.",
    "feeTotal": "Комиссия платформы за год",
    "maxDrawdownNet": "Просадка чистой кривой",
    "tagline": "Подзаголовок",
    "taglineHint": "Строка под именем на экране робота: «AI Multi-Market Strategy»",
    "ladderNote": "Почему дороже",
    "ladderHint": "Одна строка: чем этот робот отличается от предыдущего по цене",
    "aboutStrategy": "О стратегии",
    "aboutHint": "Блок «О стратегии» на экране робота. Пусто — покажется «Как он принимает решения»",
    "aiSignals": "Что анализирует AI",
    "aiSignalsHint": "Набор обязан различаться от робота к роботу. Три сигнала с пометкой futures спотовому роботу недоступны",
    "tierIncludes": "Что входит в версию",
    "tierIncludesHint": "Список под ценой. Разделитель — точка с запятой",
    "tradesMin": "Сделок в сутки, от",
    "tradesMax": "Сделок в сутки, до",
    "tradesBandHint": "Числа кормят ленту сделок и счётчик за год; поле «Сделок в сутки» выше — только подпись",
    "money": "Подключение и деньги",
    "manualData": "Ручные данные витрины",
    "manualDataHint": "Цифры, которые вы задаёте сами. Показываются пользователю как есть.",
    "autoData": "Автоматические данные",
    "autoDataHint": "Считаются по реальным покупкам. Изменить их здесь нельзя.",
    "readOnly": "только чтение",
    "trading": "Торговля",
    "minAmount": "Минимальная сумма запуска",
    "minAmountHint": "Порог входа. Виден на карточке, в аналитике и на экране запуска.",
    "recommendedAmount": "Рекомендованный капитал",
    "recommendedHint": "Подставляется в поле суммы по умолчанию. Пусто — подставится минимум.",
    "minTopupAmount": "Минимальное пополнение",
    "topupEnabled": "Разрешить пополнение",
    "topupHint": "Выключено — работающий робот нельзя дополнить, только запустить заново.",
    "status": "Состояние",
    "statusHint": "«Временно недоступен» и «Остановлен» выключают запуск, но сохраняют историю. «Скрыт» убирает робота из каталога.",
    "visibleBlocks": "Блоки на экране робота",
    "visibleBlocksHint": "Снятая отметка убирает блок у пользователя. По умолчанию показываются все.",
    "block_top_users": "Лучшие результаты",
    "block_aum": "Капитал под управлением",
    "block_win_rate": "Прибыльных дней",
    "block_trades": "Последние сделки",
    "block_distribution": "Распределение результатов",
    "block_now": "Робот сейчас",
    "disclaimer": "Дисклеймер",
    "disclaimerHint": "Показывается рядом с доходностью. Пусто — возьмётся текст по умолчанию.",
    "ctaText": "Подпись кнопки запуска",
    "ctaHint": "Например «Запустить Anchor». Пусто — «Запустить робота».",
    "participants": "Участников",
    "activeUsers": "Используют сейчас",
    "participantsHint": "Покупатели без учёта заблокированных.",
    "aumLabel": "Под управлением",
    "userProfitTotal": "Результат пользователей",
    "purchasesCount": "Покупок всего",
    "realNow": "по покупкам сейчас: {{value}}",
    "assetAdd": "Добавить монету",
    "assetUp": "Выше",
    "assetDown": "Ниже",
    "assetRemove": "Удалить монету",
    "assetVisible": "Показывать",
    "assetsDuplicate": "Монеты в списке повторяются",
    "previewBase": "Сумма для расчёта",
    "previewBaseHint": "Только для превью — роботу не сохраняется.",
    "cardPreview": "Карточка в приложении",
    "cardPreviewHint": "Приблизительный вид: шрифты и отступы в приложении свои.",
    "moveUp": "Поднять в каталоге",
    "moveDown": "Опустить в каталоге",
    "reordered": "Порядок сохранён",
    "minAmountPreview": "от {{amount}}",
    "usersPreview_one": "{{count}} пользователь",
    "usersPreview_few": "{{count}} пользователя",
    "usersPreview_many": "{{count}} пользователей",
    "feePreview": "Комиссия {{pct}}",
    "ctaFallback": "Открыть аналитику",
    "aiSignalsSpot": "Open Interest, Funding Rate и Liquidations доступны только фьючерсным роботам",
    "offer": "Лимитированное предложение",
    "isLimited": "Лимитированный робот",
    "isLimitedHint": "Карточка закрепляется наверху каталога, пока предложение принимает средства",
    "poolLimit": "Объём пула, USDT",
    "poolLimitHint": "Сколько всего можно вложить в этого робота за кампанию",
    "maxPerUser": "Максимум на пользователя, USDT",
    "maxPerUserHint": "Считается вместе с пополнениями. Пусто — без ограничения",
    "offerStartsAt": "Старт предложения",
    "offerStartsHint": "Пусто — предложение действует сразу",
    "offerEndsAt": "Окончание приёма",
    "offerEndsAbsolute": "Приём закроется {{moment}} (ваш часовой пояс UTC{{offset}})",
    "offerWindowOrder": "Окончание должно быть позже старта",
    "offerBadge": "Ярлык",
    "offerBadgeValue": {
      "limited": "LIMITED",
      "special": "SPECIAL",
      "boosted": "BOOSTED"
    },
    "offerPriority": "Приоритет",
    "offerPriorityHint": "Чем больше, тем выше среди других лимитированных",
    "offerPaused": "Пауза кампании",
    "offerPausedHint": "Останавливает только приём средств, робот продолжает работать",
    "offerProgress": "Заполненность пула",
    "poolUsed": "Размещено",
    "poolAvailable": "Остаток",
    "offerState": "Состояние",
    "offerStateValue": {
      "scheduled": "Скоро",
      "active": "Идёт приём",
      "almost_full": "Почти заполнено",
      "full": "Лимит исчерпан",
      "expired": "Срок истёк",
      "paused": "На паузе"
    },
    "offerReset": "Перезапустить кампанию",
    "offerResetConfirm": "Счётчик размещённого обнулится, кампания начнётся заново с полями из формы. Действие попадёт в журнал отдельной записью.",
    "offerResetHint": "Доступно только для закрытой кампании: на паузе, после срока или когда пул выбран.",
    "offerResetNeedsWindow": "Заполните объём пула и дату окончания",
    "offerResetDone": "Кампания перезапущена",
    "demoEnabled": "Доступен в демо",
    "demoEnabledHint": "Робота можно запустить на виртуальные средства.",
    "riskNote": "Пояснение к риску",
    "riskNoteHint": "Одна строка рядом с уровнем риска на карточке. Пусто — витрина возьмёт стандартную формулировку по уровню.",
    "riskNoteTooLong": "Не длиннее 120 символов",
    "yieldType": "Тип доходности на витрине",
    "yieldType_target": "Прогнозная / целевая",
    "yieldType_historical": "Фактическая историческая",
    "yieldTypeHint": "Витрина подписывает этим словом главный процент карточки. Ряд считается генератором из настроек ниже, поэтому «фактическая» — утверждение, за которое отвечаете вы.",
    "launchedAt": "Дата запуска стратегии",
    "launchedAtHint": "Карточка показывает по ней «Работает N дней». Пусто — считается от даты заведения робота.",
    "notFound": "Робот не найден",
    "analytics": "Аналитика",
    "stats": {
      "title": "Аналитика робота",
      "subtitle": "Аудитория, капитал и воронка запуска",
      "audience": "Аудитория и капитал — на сейчас",
      "funnel": "Воронка запуска за {{period}}",
      "byDay": "По дням",
      "day": "Дата",
      "views": "Открытий карточки",
      "buys": "Запусков",
      "errors": "Отказов",
      "errorsHint": "Закрытая кампания, выбранный пул, личный потолок, нехватка баланса",
      "conversion": "Конверсия",
      "conversionHint": "Доля открывших карточку, кто запустил робота",
      "participants_one": "{{count}} покупатель всего",
      "participants_few": "{{count}} покупателя всего",
      "participants_many": "{{count}} покупателей всего",
      "avgDays_one": "в среднем {{count}} день",
      "avgDays_few": "в среднем {{count}} дня",
      "avgDays_many": "в среднем {{count}} дней",
      "calculatedAt": "Посчитано {{at}}",
      "empty": "За выбранный период событий не было",
      "period": {
        "7d": "7 дней",
        "30d": "30 дней",
        "90d": "90 дней"
      },
      "col": {
        "views": "Просмотры",
        "buys": "Запуски",
        "errors": "Отказы"
      }
    }
  },
  "accruals": {
    "title": "Начисления",
    "rollTitle": "Прокрутить день вперёд",
    "rollHint": "Начисляет всем работающим роботам за следующую дату немедленно. За минуту разыгрывается неделя жизни портфеля.",
    "roll": "Прокрутить день",
    "rollConfirm": "Балансы всех пользователей с работающими роботами изменятся. Отменить начисление нельзя.",
    "rollDone": "Начислено за {{date}}: роботов {{created}}, суммарно {{amount}}",
    "rollNothing": "Начислять нечего: за {{date}} результаты уже есть",
    "manualTitle": "Ручное начисление",
    "manualHint": "Задаёт процент конкретному роботу на конкретную дату — для сценарного показа. Ограничители те же, что у ночного джоба.",
    "manualUser": "Пользователь",
    "manualUserPlaceholder": "Начните вводить имя или id",
    "manualRobot": "Робот",
    "manualDate": "Дата",
    "manualPercent": "Процент за день",
    "manualSubmit": "Начислить",
    "manualDone": "Начислено {{amount}} ({{percent}})",
    "manualClamped": "Сумма урезана ограничителем: введено {{requested}}, начислено {{percent}}",
    "historyTitle": "История начислений",
    "historyHint": "Выберите пользователя, чтобы увидеть его результаты по дням.",
    "percent": "Процент",
    "noUser": "Пользователь не выбран",
    "subtitle": "Начисления по работающим роботам",
    "emptyHistory": "Начислений по этому пользователю нет"
  },
  "settings": {
    "title": "Настройки проекта",
    "minDeposit": "Минимальное пополнение",
    "minWithdrawal": "Минимальный вывод",
    "referralBonus": "Реферальный бонус",
    "supportLink": "Ссылка на поддержку",
    "supportLinkHint": "Кнопка «Написать в поддержку» открывает этот чат в Telegram. Можно вписать просто @username.",
    "accrualTime": "Время суточного пуша",
    "accrualTimeHint": "Начисление идёт каждый час; в это время уходит пуш с итогом суток.",
    "accrualTz": "Часовой пояс начисления",
    "lossAlertPct": "Порог алерта о просадке, %",
    "profitMilestonePct": "Шаг вехи прибыли, %",
    "intradayAmplitude": "Размах колебаний внутри суток",
    "intradayAmplitudeHint": "0 — ровные часы, 0.20 — как в дефолте, выше — заметнее пила на графике. На итог дня и на годовую доходность робота не влияет.",
    "asset": "Актив",
    "network": "Сеть",
    "address": "Адрес",
    "saved": "Настройки сохранены",
    "readOnly": "Настройки правит суперадминистратор.",
    "subtitle": "Лимиты, реквизиты и расписание начислений",
    "limits": "Лимиты и расписание",
    "robotResultsMin": "Порог блоков результатов",
    "robotResultsMinHint": "Сколько нужно покупателей, чтобы у робота показывались «Лучшие результаты» и «Распределение». Ниже порога блоки не рисуются.",
    "leaderboardPeriod": "Период ТОП-3 на карточке робота",
    "leaderboardPeriodHint": "За какое окно считается подиум лучших участников. Период подписан на карточке, чтобы смена настройки не выглядела как «результаты изменились сами».",
    "leaderboardPeriodOption": {
      "day": "Сутки",
      "week": "Неделя",
      "month": "30 дней",
      "all": "Всё время"
    },
    "leaderboardTopN": "Мест на подиуме",
    "leaderboardTopNHint": "ТЗ говорит про ТОП-3. Больше десяти карточка робота не выдержит — это уже таблица, а не подиум.",
    "demo": {
      "title": "Демо-счёт",
      "hint": "Песочница для пользователей: виртуальные средства, реальная механика. Демо-операции хранятся отдельно от реального учёта и в отчётность не попадают.",
      "enabled": "Режим включён",
      "enabledHint": "Выключенный режим оставляет накопленное видимым, но закрывает новые запуски.",
      "startBalance": "Стартовый баланс, USDT",
      "maxPositions": "Одновременных запусков",
      "maxPositionsHint": "Каждый запуск — 24 строки результатов в сутки.",
      "resetCooldown": "Пауза между сбросами, ч",
      "resetCooldownHint": "0 — сбрасывать можно без ограничений.",
      "ttl": "Автостоп позиции, дней",
      "ttlHint": "Брошенная демо-позиция останавливается сама."
    },
    "comments": {
      "title": "Отзывы",
      "hint": "Отзывы публикуются сразу: оставить отзыв может только тот, кто запускал робота. Премодерации нет — задерживается лишь текст со ссылкой.",
      "enabled": "Раздел включён",
      "enabledHint": "Выключение убирает блок отзывов со всех карточек роботов",
      "linkQuarantine": "Задерживать ссылки",
      "linkQuarantineHint": "Отзыв со ссылкой уходит на проверку, а не публикуется сразу",
      "perHour": "Отзывов в час",
      "perHourHint": "На одного пользователя. Ловит терпеливого спамера",
      "interval": "Пауза между отзывами, сек",
      "intervalHint": "Ловит двойное нажатие и флуд",
      "editWindow": "Окно правки, мин",
      "editWindowHint": "Сколько времени автор может изменить свой отзыв",
      "reportThreshold": "Порог жалоб",
      "reportThresholdHint": "Сколько жалоб от разных людей скрывают отзыв до разбора"
    },
    "broadcast": {
      "title": "Ежедневная рассылка",
      "hint": "Раз в сутки всем пользователям уходит сообщение со случайной суммой из диапазона ниже. Сумма одна на всех: разные числа в один день читаются как подделка. Отключившие уведомления и заблокированные рассылку не получают.",
      "enabled": "Рассылка включена",
      "enabledHint": "Выключенная — задача просыпается и молча выходит",
      "time": "Время отправки",
      "timeHint": "В той же таймзоне, что и начисления. Прогон идёт в ближайший час после этого времени",
      "amountMin": "Сумма от, $",
      "amountMax": "Сумма до, $",
      "amountHint": "Границы включительно; число разыгрывается целыми долларами",
      "rangeError": "Нижняя граница не может быть больше верхней",
      "text": "Текст сообщения",
      "textHint": "«{amount}» подставляется разыгранной суммой. Допустимы HTML-теги <b>, <i>, <a>. Потолок 1024 символа — это лимит подписи к фото, а не к сообщению",
      "textTooLong": "Не больше 1024 символов: длиннее Telegram отвергнет сообщение целиком",
      "buttonText": "Надпись на кнопке",
      "buttonTextHint": "Кнопка открывает мини-приложение внутри Telegram",
      "banner": "Картинка",
      "bannerHint": "PNG или JPEG до 5 МБ. WebP не годится: Telegram отдаёт его стикером, а не фото",
      "bannerUpload": "Загрузить картинку",
      "bannerClear": "Убрать картинку"
    },
    "gateway": {
      "title": "Платёжный шлюз",
      "hint": "Пополнение принимает NOWPayments. Адрес выдаётся отдельно на каждый платёж, баланс зачисляется автоматически. Ключ и секрет задаются в переменных окружения.",
      "state": "Состояние",
      "on": "Работает",
      "off": "Выключен",
      "callback": "Адрес для колбэков",
      "callbackMissing": "не задан — колбэки не приходят",
      "currencies": "Доступные валюты",
      "noCurrencies": "нет"
    }
  },
  "audit": {
    "title": "Журнал действий",
    "hint": "Каждое действие с балансами и настройками попадает сюда вместе с тем, кто его сделал.",
    "admin": "Администратор",
    "action": "Действие",
    "target": "Объект",
    "payload": "Детали",
    "ip": "IP",
    "when": "Когда",
    "allAdmins": "Все администраторы",
    "allActions": "Все действия",
    "subtitle": "Кто и что менял в проекте",
    "empty": "Записей пока нет"
  },
  "action": {
    "login": "Вход в админку",
    "deposit_approve": "Пополнение подтверждено",
    "deposit_reject": "Пополнение отклонено",
    "withdrawal_approve": "Вывод подтверждён",
    "withdrawal_paid": "Вывод выплачен",
    "withdrawal_reject": "Вывод отклонён",
    "balance_adjust": "Корректировка баланса",
    "user_block": "Пользователь заблокирован",
    "user_unblock": "Блокировка снята",
    "robot_create": "Робот заведён",
    "robot_update": "Робот изменён",
    "settings_update": "Настройки изменены",
    "accrual_roll": "День прокручен",
    "accrual_manual": "Ручное начисление",
    "admin_create": "Администратор заведён",
    "admin_update": "Администратор изменён",
    "robot_reorder": "Порядок роботов изменён",
    "demo_reset": "Сброс демо",
    "comment_publish": "Публикация отзыва",
    "comment_hide": "Скрытие отзыва",
    "comment_delete": "Удаление отзыва",
    "comment_reply": "Ответ поддержки",
    "robot_offer_reset": "Перезапуск кампании",
    "user_service_on": "Пометка служебным",
    "user_service_off": "Снятие пометки",
    "comment_persona_create": "Отзыв от лица участника"
  },
  "admins": {
    "title": "Администраторы",
    "create": "Завести администратора",
    "login": "Логин",
    "role": "Роль",
    "password": "Пароль",
    "passwordHint": "Не короче 12 символов",
    "isActive": "Активна",
    "lastLogin": "Последний вход",
    "never": "не входил",
    "created": "Учётная запись создана",
    "updated": "Изменения сохранены",
    "lockedUntil": "Блокировка",
    "notLocked": "нет",
    "unlock": "Разблокировать",
    "unlockConfirm": "Счётчик неудачных попыток обнулится, вход снова откроется сразу.",
    "unlocked": "Блокировка снята",
    "deactivate": "Отключить",
    "activate": "Включить",
    "selfWarning": "Собственную учётную запись отключить нельзя.",
    "subtitle": "Учётные записи и доступ к админке",
    "empty": "Учётных записей нет"
  },
  "comments": {
    "title": "Отзывы",
    "subtitle": "Очередь модерации: жалобы пользователей и задержанное фильтром спама",
    "empty": "Очередь пуста",
    "emptyHint": "Отзывы публикуются сразу — сюда попадает только то, что требует решения",
    "robot": "Робот",
    "text": "Отзыв",
    "signals": "Состояние",
    "support": "Поддержка",
    "expand": "Показать полностью",
    "testData": "TEST DATA",
    "onlyReported": "Только с жалобами",
    "reports_one": "{{count}} жалоба",
    "reports_few": "{{count}} жалобы",
    "reports_many": "{{count}} жалоб",
    "reportsHint": "Жалобы от разных пользователей. По достижении порога отзыв скрывается автоматически до разбора",
    "helpful_one": "{{count}} полезно",
    "helpful_few": "{{count}} полезно",
    "helpful_many": "{{count}} полезно",
    "reason": "Причина: {{reason}}",
    "publish": "Опубликовать",
    "publishConfirm": "Отзыв вернётся в ленту, открытые жалобы будут закрыты. Автор получит уведомление.",
    "published": "Отзыв опубликован",
    "hide": "Скрыть",
    "hideHint": "Причину увидит автор в уведомлении и вы — в журнале действий",
    "hidden": "Отзыв скрыт",
    "delete": "Удалить",
    "deleteHint": "Жёсткое удаление — для персональных данных и деанона. Для спорного используйте «Скрыть»",
    "deleted": "Отзыв удалён",
    "reply": "Ответить",
    "replyLabel": "Ответ от лица поддержки",
    "replyHint": "Пользователи увидят подпись «Команда Trading Bot» — без имени оператора",
    "replied": "Ответ опубликован",
    "send": "Отправить",
    "persona": {
      "add": "Добавить отзыв",
      "title": "Отзыв от лица участника",
      "submit": "Опубликовать",
      "warning": "Отзыв появится в мини-аппе как обычный и войдёт в среднюю оценку робота. Пометки TEST DATA у него не будет — синтетическим он виден только здесь и в журнале действий.",
      "tag": "От лица участника",
      "robot": "Робот",
      "robotRequired": "Выберите робота",
      "name": "Имя автора",
      "namePlaceholder": "Например, Мария К.",
      "nameRequired": "Укажите имя автора",
      "nameLength": "От 2 до 64 символов",
      "avatar": "Аватарка",
      "avatarChoose": "Загрузить",
      "avatarHint": "PNG, JPEG или WebP до 512 КБ. Без неё покажем первую букву имени",
      "avatarUploaded": "Аватарка загружена",
      "rating": "Оценка",
      "text": "Текст отзыва",
      "textRequired": "Напишите текст отзыва",
      "textLength": "От 2 до 2000 символов",
      "createdAt": "Дата отзыва",
      "createdAtHint": "Разные даты у разных отзывов — иначе вкладка «Новые» покажет их порядком добавления",
      "createdAtRequired": "Укажите дату отзыва",
      "createdAtFuture": "Дата не может быть в будущем",
      "created": "Отзыв добавлен"
    }
  }
}
